/* eslint object-curly-newline: 'off' */

const layoutAssembly = [
  { name: 'topsilkscreen', offset: 0.9 },
  { name: 'topsoldermask', offset: 0.85 },
  { name: 'toplayer', offset: 0.8 },
  { name: 'board', offset: -0.8 },
  { name: 'drills', offset: -0.8 },
  { name: 'holes', offset: -0.8 },
  { name: 'bottomlayer', offset: -0.85 },
  { name: 'bottomsoldermask', offset: -0.9 },
  { name: 'bottomsilkscreen', offset: -1.0 },
];

const layoutReal = [
  { name: 'topsilkscreen', offset: 0.9 },
  { name: 'topsoldermask', offset: 0.85 },
  { name: 'toplayer', offset: 0.8 },
  { name: 'board', offset: -0.8 },
  { name: 'drills', offset: -0.8 },
  { name: 'holes', offset: -0.8 },
  { name: 'millinglv1', offset: -0.8 },
  { name: 'millinglv2', offset: -0.8 },
  { name: 'bottomlayer', offset: -0.85 },
  { name: 'bottomsoldermask', offset: -0.9 },
  { name: 'bottomsilkscreen', offset: -1.0 },
];

const layoutRealStencil = [
  { name: 'toppaste', offset: 1.0 },
  { name: 'topsoldermask', offset: 0.85 },
  { name: 'toplayer', offset: 0.8 },
  { name: 'board', offset: -0.8 },
  { name: 'bottomlayer', offset: -0.85 },
  { name: 'bottomsoldermask', offset: -0.9 },
  { name: 'bottompaste', offset: -1.0 },
];

const layoutStackedLayers = (layerCount) => {
  const internalLayerCount = layerCount - 2;
  const sideCount = (internalLayerCount / 2) + 0.5;

  const stackup = [{ name: 'boardoutline', offset: 0.0 }];

  for (let i = 1; i <= internalLayerCount; i += 1) {
    const layer = {
      name: `internalplane${i}`,
      offset: (sideCount - i) * 0.1,
    };
    stackup.push(layer);
  }

  stackup.unshift(
    { name: 'toplayer', offset: (sideCount * 0.1) + 0.1 },
  );
  stackup.push(
    { name: 'bottomlayer', offset: (sideCount * -0.1) - 0.1 },
    { name: 'drills', offset: (sideCount * -0.1) - 0.1 },
    { name: 'holes', offset: (sideCount * -0.1) - 0.1 },
  );

  stackup.sort((a, b) => b.offset - a.offset);
  return stackup;
};

export default { layoutAssembly, layoutReal, layoutStackedLayers, layoutRealStencil };
